import React, { useEffect, useState } from 'react';
import { ComboBox, IComboBoxOption, Label } from '@fluentui/react';
import { t } from 'i18next';
import TimeTaxSupportSystemClient from '../../system/TimeTaxSupportSystemClient';

export interface OptionPais {
  key: string;
  text: string;
}

interface PaisSelectorProps {
  system: TimeTaxSupportSystemClient;
  label?: string;
  defaultValue?: string;
  disabled?: boolean;
  className?: string;
  onChangeSelected: (selected: OptionPais | null) => void;
}

const PaisDropdown: React.FC<PaisSelectorProps> = ({
  system,
  label,
  defaultValue,
  disabled = false,
  className,
  onChangeSelected,
}) => {
  const [options, setOptions] = useState<IComboBoxOption[]>([]);
  const [selectedKey, setSelectedKey] = useState<string>(
    defaultValue ?? ''
  );

  useEffect(() => {
    const loadCountries = async () => {
      try {
        const data = await system
          .getCompanySystem()
          .getPaises('paises', 'list-paises', 1);

        setOptions([
          {
            key: '',
            text: t('Todos'),
          },
          ...data.map((item) => ({
            key: item.key,
            text: item.text,
          })),
        ]);
      } catch (error) {
        console.error(error);
      }
    };

    loadCountries();
  }, [system]);

  return (
    <div className={className}>
      {label && <Label>{label}</Label>}

      <ComboBox
        options={options}
        selectedKey={selectedKey}
        disabled={disabled}
        autoComplete="on"
        allowFreeform
        useComboBoxAsMenuWidth
        onChange={(_, option) => {
          const value = option
            ? {
                key: String(option.key),
                text: option.text,
              }
            : null;

          setSelectedKey(String(option?.key ?? ''));
          onChangeSelected(value);
        }}
      />
    </div>
  );
};

export default PaisDropdown;